import { Dialog } from "@headlessui/react"
import React, { FC, useState } from "react"
import { X } from "heroicons-react"
import { KButton, KInput, KSpan, KTextArea, KTitleSpan } from "kahuna-base-react-components"
import { releases } from "../../../../../apis"
import { errorFilledToastOptions, successFilledToastOptions } from "../../../../../constants"
import { toast } from "react-toastify"

type AdminNewLabelModalProps = {
  open: boolean
  onClose: () => void
}
const AdminNewLabelModal: FC<AdminNewLabelModalProps> = (props) => {
  const { onClose, open } = props

  const [label, setLabel] = useState<string>("")
  const [loading, setLoading] = useState(false)

  const onCloseModal = () => {
    setLabel("")
    onClose()
  }

  const onCreate = () => {
    setLoading(true)
    releases(`/release/label_camp_label_create/`, "post", { label }).then((resp) => {
      if (resp.data.success) {
        onCloseModal()
        toast.success("Label added successfully", successFilledToastOptions)
      } else {
        toast.error(resp.data.message, errorFilledToastOptions)
      }
      setLoading(false)
    })
  }

  return (
    <Dialog open={open} onClose={() => onCloseModal()} className="relative">
      <div className="fixed inset-0 bg-[rgba(0,0,0,0.3)]" aria-hidden="true" />
      <div className="fixed inset-0 flex items-center justify-center p-4">
        <div>
          <div className={`flex justify-end`}>
            <X className="h-4 cursor-pointer mt-1" style={{ position: "absolute" }} onClick={() => onCloseModal()} />
          </div>
          <div className="bg-white elev-b-sm rounded-lg overflow-hidden w-[450px] flex flex-col gap-4 p-10">
            <KTitleSpan text={"Add Label"} fontSize={24} />

            <KInput value={label} onChange={(text) => setLabel(text)} placeholder="Label..." />

            <div className="flex pt-4">
              <KButton text="Cancel" background="white" shadowDisabled={true} onClick={() => onCloseModal()} />
              <KButton
                text="Create"
                background="black"
                textColor="white"
                onClick={() => onCreate()}
                disabled={!label || loading}
              />
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  )
}

export default AdminNewLabelModal
